import { QuizQuestionItem } from "../content.types";
import { QuizItemStatuses } from "./enums";

export * from "./enums";

export const INITIAL_QUIZ_ITEM_FORM_VALUES: QuizQuestionItem = {
  status: QuizItemStatuses.Active,
  mediaId: null,
  media: null,
  question: "",
  description: null,
  answers: [
    {
      answer: "",
      isCorrect: false
    },
    {
      answer: "",
      isCorrect: true
    }
  ]
};

export const MAX_MEDIA_FIELDS_IN_INSERT_FORM = 20;
